import { useSuspenseQuery } from '@apollo/client';
import { UpdateVisibleUnitsForm } from '@features/preferencesCommon';
import { type FC } from 'react';
import { GET_ORGANIZATION_PREFERENCES_VISIBLE_UNITS } from '../graphql/queries/getOrganizationPreferencesVisibleUnits';
import { TabProps } from '../types';

export const VisibleUnitsTab: FC<TabProps> = ({ organizationId: userId }) => {
  const { data } = useSuspenseQuery(GET_ORGANIZATION_PREFERENCES_VISIBLE_UNITS, {
    variables: {
      input:
        userId != null
          ? {
              id: userId,
            }
          : null,
    },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <UpdateVisibleUnitsForm
      entity={{
        type: 'organization',
        id: userId,
      }}
      data={data.organization.preferences.visibleUnits}
      factoryDefaults={data.organization.preferences.defaultValues}
    />
  );
};
